import { GroupProps } from "./GroupProps";
import { SectionStateAndComponent } from "./Filters";

const FilterSort = (sortOrder: ((props: GroupProps) => JSX.Element)[]) => {
  const map = [...sortOrder];
  return (a: SectionStateAndComponent, b: SectionStateAndComponent) => {
    let indexOfA = map.indexOf(a.Component);
    let indexOfB = map.indexOf(b.Component);
    if (indexOfA === -1 || indexOfB === -1) {
      // Just in case we are passed a shortened list
      indexOfA = indexOfA === -1 ? Infinity : indexOfA;
      indexOfB = indexOfB === -1 ? Infinity : indexOfB;
    }
    if (indexOfA < indexOfB) {
      return -1;
    }
    if (indexOfA > indexOfB) {
      return 1;
    }
    return 0;
  };
};

export default FilterSort;
